import { Component, EventEmitter, Output } from '@angular/core';
import { BaseTableComponent } from '../../../../shared/tables/base-table/base-table';
import { SchoolGroupResponseDto, UserTypeEnum } from '@whetstoneeducation/hero-common';
import { SchoolGroupsListColumns } from '../school-groups-list-models/school-groups-list-columns.enum';
import { AppPrivilegesService } from '../../../auth/privileges.service';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';

@Component({
  selector: 'app-school-groups-table',
  templateUrl: './school-groups-list-table.template.html',
  styleUrls: ['./school-groups-list-table.scss'],
})
export class AppSchoolGroupsListTableComponent extends BaseTableComponent<SchoolGroupResponseDto> {
  @Output() toggleDeactivateSchoolGroup = new EventEmitter();

  public get displayedColumns(): string[] {
    return Object.values(SchoolGroupsListColumns) as string[];
  }

  public columnValues = {
    [SchoolGroupsListColumns.NAME]: ["name"],
    [SchoolGroupsListColumns.DESCRIPTION]: ["description"],
    [SchoolGroupsListColumns.ACTIVE]: ["deactivatedAt"],
  };

  public columns = SchoolGroupsListColumns;

  isInternalAdmin = this.isUserType([UserTypeEnum.INTERNAL_ADMIN]);

  constructor(
    public privilegesService: AppPrivilegesService,
    public toastManager: AppToastManagerService,
  ) {
    super({ privilegesService });
  }

  public onToggleDeactivateSchool(school: SchoolGroupResponseDto) {
    this.toggleDeactivateSchoolGroup.emit(school);
  }
}
